import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { fuseAnimations } from 'src/@fuse/animations';
import { SharedModule } from 'src/app/shared/shared.module';
import { SharedService } from 'src/app/shared/shared.service';
import { LoadingComponent } from '../generals/loading/loading.component';
import { MySignatureComponent } from './my-signature/my-signature.component';
import { MyBusinessComponent } from './my-business/my-business.component';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    MatButtonModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FormsModule,

    LoadingComponent,
    MySignatureComponent,
    MyBusinessComponent,
    SharedModule,
  ],
  animations: fuseAnimations,
})
export class ProfileComponent implements OnInit, OnDestroy {
  private _formBuilder = inject(FormBuilder);
  private _sanitizer = inject(DomSanitizer);
  private sharedService = inject(SharedService);
  private _unsubscribeAll!: Subject<any>;
  isLinear = false;
  imagenForm!: FormGroup;
  imagen: any;
  nombreUsuario = '';
  account$: any;
  id = 0;
  disableMyBussines = false;

  ngOnInit(): void {
    this.loadImagen();
    this.changeMyBussinesTab();
    this._unsubscribeAll = new Subject();
  }

  loadImagen(): void {
    this.imagen = {};
    this.createFormImagen();
  }

  changeMyBussinesTab(): void {
    this.sharedService.signature$?.subscribe(signature => {
      this.disableMyBussines =
        signature.id < 1 || signature.isDateExpired ? true : false;
    });
  }

  createFormImagen(): void {
    this.imagenForm = this._formBuilder.group({
      id: [this.imagen.id],
      imagen: ['', Validators.required],
      imagenContentType: ['', Validators.required],
    });
  }

  handleFile(event: any): void {}

  sanitizeImagen(account: any): any {
    const imagen = account.userImagenPerfil;
    if (imagen) {
      return this._sanitizer.bypassSecurityTrustResourceUrl(
        'data:' + imagen.imagenContentType + ';base64, ' + imagen.imagen,
      );
    } else {
      return './assets/images/default-avatar.png';
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(void 0);
    this._unsubscribeAll.complete();
  }
}
